import { useLocation } from "wouter";
import { parseAuthState } from "@/features/auth/utils/auth-state";
import { useEffect } from "react";

/*
 * AuthCallbackRoute component
 *
 * Extract the auth_code after a successful Auth0 login and navigate to the account selection page.
 */
export const AuthCallbackRoute = () => {
  /* Stores */
  const [, navigate] = useLocation();
  const urlParams = new URLSearchParams(window.location.search);

  /* URL */
  const code = urlParams.get("code");
  const state = urlParams.get("state");

  useEffect(() => {
    // Parse and validate the state parameter to protect against CSRF attacks and ensure the returnTo URL is safe
    const { isValid, returnTo } = parseAuthState(state);

    // If there's a valid code and the state is valid, navigate to the account selection page
    if (code && isValid) {
      navigate("/auth/select-account", { replace: true, state: { code, returnTo } });
    } else {
      // Either the code is missing or the state is invalid, which could indicate a CSRF attack or a malformed URL
      console.error("Invalid auth callback state:", { code, state });
    }
  }, [code, state, navigate]);

  /* Return */
  return (
    <div className="flex flex-col items-center justify-center h-screen">
      <h1 className="mb-2">Invalid sign-in response</h1>
    </div>
  );
};
